import React from 'react';

import CheckboxFormField from 'CommonComponents/CheckboxFormField';
import SelectField from 'CommonComponents/SelectField';
import SelectFromField from 'CommonComponents/SelectFromField';

export function VenueSelector(props) {
    const valueKey = props.valueKey || 'venue_ids';

    return (
        <div className="tw-flex tw-flex-col tw-space-y-1.5">
            <label htmlFor="venue" className="text-input__label">
                {props.label || $t('Venue')}
            </label>
            <SelectField
                className="tw-block tw-w-full tw-rounded-lg tw-text-sm !tw-bg-grey/50 tw-text-charcoal tw-font-semibold placeholder:tw-text-charcoal-75 placeholder:tw-text-sm placeholder:tw-font-normal"
                options={props.venuesOptions}
                value={props.values[valueKey]}
                isGrouped={true}
                isDisabled={props.disabled}
                onChange={(venues) => props.onChange(venues)}
                backgroundColor="#e4e4e480"
                height={32}
                isMulti
                clearable
                menuPortalTarget={null}
            />
            {props.touched && props.errors ? <div className="tw-text-red-500 tw-text-sm">{props.errors}</div> : null}
        </div>
    );
}

export function DepartmentSelector(props) {
    return (
        <div className="tw-flex tw-flex-col tw-space-y-1.5">
            <label htmlFor="department" className="text-input__label">
                {props.label || $t('Select a department or cost center')}
            </label>
            <SelectField
                className="tw-block tw-w-full tw-rounded-lg tw-text-sm !tw-bg-grey/50 tw-text-charcoal tw-font-semibold placeholder:tw-text-charcoal-75 placeholder:tw-text-sm placeholder:tw-font-normal"
                options={props.departmentsOptions}
                value={props.values.budget_department_key}
                isDisabled={props.disabled}
                onChange={(department) => props.onChange(department)}
                backgroundColor="#e4e4e480"
                height={32}
                isGrouped
                clearable
                menuPortalTarget={null}
            />
            {props.touched && props.errors ? <div className="tw-text-red-500 tw-text-sm">{props.errors}</div> : null}
        </div>
    );
}

export function BudgetLineSelector(props) {
    return (
        <div className="tw-flex tw-flex-col tw-space-y-1.5">
            <label htmlFor="budget_line_id" className="text-input__label">
                {props.label || $t('Attach to')}
            </label>
            <SelectField
                className="tw-block tw-w-full tw-rounded-lg tw-text-sm !tw-bg-grey/50 tw-text-charcoal tw-font-semibold placeholder:tw-text-charcoal-75 placeholder:tw-text-sm placeholder:tw-font-normal"
                options={props.budgetLines}
                value={props.value ?? props.values.budget_line_id}
                isGrouped={true}
                isDisabled={props.disabled}
                onChange={(budgetLine) => {
                    if (props.onChange) {
                        props.onChange(budgetLine);
                        return;
                    }

                    props.setFieldValue('budget_line_id', budgetLine?.value || '');
                    props.setFieldValue('budget_line_type', budgetLine?.type || '');
                }}
                backgroundColor="#e4e4e480"
            />
            {props.touched && props.errors ? <div className="tw-text-red-500 tw-text-sm">{props.errors}</div> : null}
        </div>
    );
}

export function ImpactSelector(props) {
    return (
        <SelectFromField label={props.label || $t('Select an impact')} as="select" name={props.name}>
            <option value="">{$t('No impact')}</option>
            {props.impacts.map(({ id, mark }) => (
                <option key={id} value={id}>
                    {mark}
                </option>
            ))}
        </SelectFromField>
    );
}

export function ImpactCategorySelector(props) {
    return (
        <div className="tw-flex tw-flex-col tw-space-y-1.5">
            <span className="tw-text-charcoal tw-text-sm">{props.label || $t('Impact Categories')}</span>
            {props.categories?.length ? (
                <div className={props.isSpanToTwo ? 'tw-grid tw-grid-cols-1 md:tw-grid-cols-2 tw-gap-4' : 'tw-grid tw-grid-cols-1 md:tw-grid-cols-3 tw-gap-4'}>
                    {props.categories.map(({ id, title }) => (
                        <CheckboxFormField key={id} label={title} type="checkbox" name={props.name} value={String(id)}></CheckboxFormField>
                    ))}
                </div>
            ) : (
                <div className="tw-text-sm tw-font-medium tw-text-charcoal">{$t('No impact category')}</div>
            )}
            {props.errors && props.touched && <div className="tw-text-red-500 tw-text-sm">{props.errors}</div>}
        </div>
    );
}

export function ProbabilitySelector(props) {
    return (
        <SelectFromField label={props.label || $t('Select a probability')} as="select" name={props.name}>
            <option value="">{$t('No probability')}</option>
            {props.probabilities.map(({ id, mark }) => (
                <option key={id} value={id}>
                    {mark}
                </option>
            ))}
        </SelectFromField>
    );
}

export function StatusSelector(props) {
    return (
        <SelectFromField label={$t('Select a status')} as="select" name={props.name}>
            <option value="">{$t('No status')}</option>
            {props.statuses.map(({ id, title }) => (
                <option key={id} value={id}>
                    {title}
                </option>
            ))}
        </SelectFromField>
    );
}

export function TypesSelector(props) {
    return (
        <SelectFromField label={$t('Select a type')} as="select" name={props.name}>
            <option value="">{$t('No types')}</option>
            {props.types.map(({ id, title }) => (
                <option key={id} value={id}>
                    {title}
                </option>
            ))}
        </SelectFromField>
    );
}

export function GeneralIssuesSelector(props) {
    return (
        <div className="tw-flex tw-flex-col tw-space-y-1.5">
            <span className="tw-text-charcoal tw-text-sm">{props.label || $t('General Issues')}</span>
            {props.issues?.length ? (
                <div className="tw-grid tw-grid-cols-1 md:tw-grid-cols-2 tw-gap-4">
                    {props.issues.map(({ id, description }) => (
                        <CheckboxFormField key={id} label={description} type="checkbox" name={props.name} value={String(id)}></CheckboxFormField>
                    ))}
                </div>
            ) : (
                <div className="tw-text-sm tw-font-medium tw-text-charcoal">{$t('No general issues')}</div>
            )}
            {props.errors && props.touched && <div className="tw-text-red-500 tw-text-sm">{props.errors}</div>}
        </div>
    );
}

export function GeneralDecisionsSelector(props) {
    return (
        <div className="tw-flex tw-flex-col tw-space-y-1.5">
            <span className="tw-text-charcoal tw-text-sm">{props.label || $t('General Decisions')}</span>
            {props.decisions?.length ? (
                <div className="tw-grid tw-grid-cols-1 md:tw-grid-cols-2 tw-gap-4">
                    {props.decisions.map(({ id, description }) => (
                        <CheckboxFormField key={id} label={description} type="checkbox" name={props.name} value={String(id)}></CheckboxFormField>
                    ))}
                </div>
            ) : (
                <div className="tw-text-sm tw-font-medium tw-text-charcoal">{$t('No general decisions')}</div>
            )}
            {props.errors && props.touched && <div className="tw-text-red-500 tw-text-sm">{props.errors}</div>}
        </div>
    );
}

export function GeneralRisksSelector(props) {
    return (
        <div className="tw-flex tw-flex-col tw-space-y-1.5">
            <span className="tw-text-charcoal tw-text-sm">{props.label || $t('General Risks')}</span>
            {props.decisions?.length ? (
                <div className="tw-grid tw-grid-cols-1 md:tw-grid-cols-2 tw-gap-4">
                    {props.decisions.map(({ id, description }) => (
                        <CheckboxFormField key={id} label={description} type="checkbox" name={props.name} value={String(id)}></CheckboxFormField>
                    ))}
                </div>
            ) : (
                <div className="tw-text-sm tw-font-medium tw-text-charcoal">{$t('No general risks')}</div>
            )}
            {props.errors && props.touched && <div className="tw-text-red-500 tw-text-sm">{props.errors}</div>}
        </div>
    );
}
